module.exports = __webpack_public_path__ + "img/crown.8099cab0.svg";